import React, { useState } from 'react';
import { ArtistDTO, PlaylistCreateDTO } from '../../spotipitan/types';
import { Spotip17anFunctions } from '../../../../utils/api';
import useUserStore from '../../../../store/UserState';
import { useNavigate } from 'react-router-dom';
import { LoginHome } from '../../../users';
import CreatePlaylistModal from '../../../shared/create-playlist-modal/create-playlist-modal';
import PaginatedPlaylistList from "../../../shared/paginated-playlist-list";

type Props = {
    headerOptions?: React.ReactNode;
    searchQuery?: string;
}

const MyPlaylists = ({ headerOptions, searchQuery }: Props) => {
    const [playlists, setPlaylists] = useState<ArtistDTO[]>([]);
    const { user } = useUserStore(state => state.state);
    const navigate = useNavigate();

    const handleCloseCreatePlaylist = () => {
        navigate('#');
    }

    const handleSavePlaylist = (playlist: PlaylistCreateDTO) => {
        Spotip17anFunctions.use('createPlaylist').call(playlist).then((res: ArtistDTO) => {
            handleCloseCreatePlaylist();
            setPlaylists([...playlists, res]);
        }).catch(e => {
            console.error(e);
        })
    }

    if (!user?.uid) {
        return (
            <div className="fade custom-modal modal show" style={{
                position: 'initial',
                opacity: 1,
                paddingBottom: '60px',
                display: 'block',
                height: 'fit-content',
            }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <LoginHome onClose={() => navigate("/")} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="d-flex align-items-center mb-4 my-playlists-header">
                <h2 className="mb-0">Mis Playlists</h2>
                <button
                    onClick={() => navigate('#create-playlist')}
                    className="create-playlist-button btn btn-link text-light ms-2 p-0"
                    style={{ fontSize: '1.5rem' }}
                >
                    <i className="fa-solid fa-plus"></i>
                </button>
                {headerOptions}
            </div>
            <PaginatedPlaylistList
                searchQuery={searchQuery}
                functionName={"myPlaylists"}
                onPlaylistClick={(playlist) => navigate(`/playlist/${playlist.id}`)}
            />
            <CreatePlaylistModal
                hash="create-playlist"
                onClose={handleCloseCreatePlaylist}
                onSave={handleSavePlaylist}
            />
        </div>
    );
};

export default MyPlaylists; 
